import React, { Component } from "react";
import { connect } from "react-redux";
import InfoHelp from "../containers/InfoHelp";
import Header from "../components/Header";

class InfoHelpView extends Component {
  render() {
    const { logo, isSellerLogoOn } = this.props
    return (
      <div>
        <Header logo={logo} hideInfoText={!isSellerLogoOn}/>
        <div className="main-container">
          <InfoHelp />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  yardPhoneNumber: state.lot.yardPhoneNumber,
  logo: state.lot.logo,
  isSellerLogoOn: state.lot.isSellerLogoOn
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoHelpView);



// WEBPACK FOOTER //
// ./src/views/InfoHelpView.js